import React from 'react';
import MarketingLink from 'core/modules/MarketingLink/MarketingLink';

function TrendingAndSeasonalOffer(props) {
  const {
    clickUrl,
    assets,
    position,
    id,
  } = props;

  return (
    <div className="mn_trendingAndSeasonalOffer" data-placement-id={id}>
      <MarketingLink
        url={clickUrl}
        data-position={position}
        title={`${assets.shortSummaryText}. Opens a new window`}
      >
        <img src={assets.image} alt={assets.imageAlternateText} />
      </MarketingLink>
    </div>
  );
}

export default TrendingAndSeasonalOffer;
